import { useMemo } from 'react';
import { getEnvAddresses } from '../config/chainConfig';

export const useEnvAddresses = () => {
  return useMemo(() => getEnvAddresses(), []);
};
